export default __webpack_public_path__ + "static/media/banner-top.72bc2eb1.jpeg";